import { createFileRoute } from "@tanstack/react-router";
import AcceleratedTmsOtherConditions from "@/pages/AcceleratedTmsOtherConditions";
export const Route = createFileRoute("/accelerated-tms-other-conditions")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Accelerated TMS for Other Conditions | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Where does TMS stand for conditions beyond depression? Learn what's FDA-cleared, what's still being researched, and what questions to ask. Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Accelerated TMS for Other Conditions | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Where does TMS stand for conditions beyond depression? Learn what's FDA-cleared, what's still being researched, and what questions to ask. Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/accelerated-tms-other-conditions",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/accelerated-tms-other-conditions",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AcceleratedTmsOtherConditions />;
}
